'use client';

import { useAchievementUnlockedSubscription } from '@/hooks/useAchievementUnlockedSubscription';
import { usePresenceHeartbeat } from '@/hooks/usePresenceHeartbeat';
import { useRushMidConfig } from '@/queries/useRushMidConfig';

/**
 * Mounts global Centrifugo subscriptions that aren't tied to a specific
 * screen. Renders nothing — side effects only. Mounted once inside
 * `(app)/AppProviders.tsx` so the achievement unlock toast fires no
 * matter which screen the user is currently on.
 */
export function GlobalSubscriptions() {
  useAchievementUnlockedSubscription();
  usePresenceHeartbeat();
  // Rush Mid gates load at app boot, before the games tile first paints.
  useRushMidConfig();
  return null;
}
